import React from 'react';
import styles from './VirtualVisitCareCard.module.css';

export const VirtualVisitCareCard: React.FC<{ template: any }> = ({
    template,
}) => {
    return (
        <div className={styles.virtualVisitCareCard}>
            <span className="info">{template.headerText}</span>
            <h3>{template.expressCareCost}</h3>
            <h4>{template.expressCareLine2}</h4>
            <br />
            <h4>{template.insuranceLine1}</h4>
            <h4>
                <a
                    href={template.insuranceLine3Link}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                >
                    {template.insuranceLine3Text}
                </a>
            </h4>
            <p className="footer">{template.footerText}</p>
        </div>
    );
};
